export default __webpack_public_path__ + "static/checkUID-d51a5459a8b0011221079e73a67ed768.png";